import React, { Component } from 'react'
import PropTypes from 'prop-types'
import showDateTime from "../../shared/ShowDateTime"
import classNames from "classnames"
import BatchPartnerInfo from "./partner/BatchPartnerInfo"
import SewingPartner from "./sewing-partner/SewingPartner"
import UserCreate from "./UserCreate"
import { Modal, Table, Tooltip, Button, message, Spin } from 'antd'
import LOCATION from '../../../helpers/batchLocations'
import BatchNote from './BatchNote'
import ChangeStatusSewing from './batch-actions/ChangeStatusSewing'
import ChangeStatusTransferred from "./batch-actions/ChangeStatusTransferred"
import { getLocalData } from '../../../services/StorageServices'
import { parseJwt } from '../../../helpers/parseToken'
import { forceToRGB, listItemBatches, retryBatchPrintedFile } from "../../../services/api/3dApi"
import _ from 'lodash'
import BatchMerge from './batch-actions/BatchMerge'

const joinMaterials = (materials, subMaterials = []) => {
    const subList = Array.isArray(subMaterials) ? subMaterials : []

    return _.compact([materials, ...subList]).join(', ')
}

class BatchInfo extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isModalOpen: false,
            isOpenForce: false,
            listItemNeedForce: [],
            loadingForce: false,
            loadingItems: false,
            hovering: false,
            retryFailed: false,
            retrySuccess: false,
        }
        this._isUnmounted = false
    }

    componentWillUnmount() {
        this._isUnmounted = true
    }

    showModal = () => {
        this.setState({ isModalOpen: true })
    }
    handleCancel = () => {
        this.setState({ isModalOpen: false })
    }

    _handleChangeModalForce = isOpenForce => {
        this.setState({
            isOpenForce,
            retryFailed: false,
            retrySuccess: false,
        })

        if (isOpenForce) {
            this._fetchBatchItems()
        }
    }

    _fetchBatchItems = async () => {
        this.setState({ loadingItems: true })
        try {
            const { batch } = this.props

            const params = {
                limit: 10000,
                page: 1,
            }

            let rqUrl = `limit=${params.limit}&page=${params.page}`

            if (params.status) {
                rqUrl += `&status=${params.status}`
            }

            if (params.type) {
                rqUrl += `&type=${params.type}`
            }

            if (params.item_overtime !== '') {
                rqUrl += `&item_overtime=${params.item_overtime}`
            }
            if (!!params.orderBy) {
                rqUrl += `&orderBy=${params.orderBy}&orderType=${params.orderSortType}`
            }

            if (params.printed_qr) {
                rqUrl += `&printed_qr=${params.printed_qr}`
            }

            const { data: response } = await listItemBatches(batch._id, rqUrl)
            const { data, success, error } = response

            if (!success) {
                throw new Error(error)
            }

            const { items = [] } = data

            const newItems = items.map(i => {
                const { item = {} } = { ...i }
                const { marketplace, item_number } = item
                return `${marketplace}_${item_number}`
            }).filter(Boolean) || []

            this.setState({ listItemNeedForce: newItems })
        } catch (e) {
            message.error(e.message)
        } finally {
            if (!this._isUnmounted) this.setState({ loadingItems: false })
        }
    }

    _handleForceToRGB = async () => {
        try {
            this.setState({ loadingForce: true, retryFailed: false, retrySuccess: false })
            const { batch } = this.props
            
            const { data: response } = await forceToRGB(batch._id)
            const { success, error } = response

            if (!success) {
                throw new Error(error)
            }

            message.success("Thêm tag force_rgb cho order thành công.")

            const retryPayload = { batchName: batch.basename, session_id: '' }
            const { data: retryResponse } = await retryBatchPrintedFile(retryPayload)

            this._handleRetryResponse(retryResponse)
        } catch (error) {
            const { batch } = this.props
            const retryPayload = { batchName: batch.basename, session_id: '' }

            try {
                const { data: retryResponse } = await retryBatchPrintedFile(retryPayload)
                this._handleRetryResponse(retryResponse)
            } catch (retryError) {
                this.setState({ retryFailed: true })
                message.error(`Gen lại file in RGB thất bại: ${retryError.message}`)
                if (typeof this.props.refreshBatchInfo === 'function') {
                    this.props.refreshBatchInfo()
                }
            }
        } finally {
            if (!this._isUnmounted) this.setState({ loadingForce: false })
        }
    }

    _handleRetryResponse = (retryResponse) => {
        if (retryResponse.success) {
            this.setState({ retrySuccess: true, retryFailed: false })
            message.success("Gen lại file in RGB thành công.")
            if (!this._isUnmounted) {
                this._handleChangeModalForce(false)
                if (typeof this.props.refreshBatchInfo === 'function') {
                    this.props.refreshBatchInfo()
                }
            }
        } else {
            this.setState({ retryFailed: true })
            message.error(`Gen lại file in RGB thất bại: ${retryResponse.error}`)
            if (typeof this.props.refreshBatchInfo === 'function') {
                this.props.refreshBatchInfo()
            }
        }
    }

    _handleManualRetry = async () => {
        try {
            this.setState({ loadingForce: true })
            const { batch } = this.props

            const retryPayload = { batchName: batch.basename, session_id: '' }
            const { data: response } = await retryBatchPrintedFile(retryPayload)

            this._handleRetryResponse(response)
        } catch (error) {
            this.setState({ retryFailed: true })
            message.error(error.message)
        } finally {
            if (!this._isUnmounted) this.setState({ loadingForce: false })
        }
    }

    _handleHovering = (isHover) => {
        this.setState({
            hovering: isHover
        })
    }
    render() {
        const { batch, error, refreshBatchInfo, total, reload, data, onActionSendMerge, loading } = this.props
        const { isOpenForce, listItemNeedForce = [], loadingForce, loadingItems, hovering, retryFailed, retrySuccess } = this.state
        const { status, created_at, product_types, preference, statistic_quantity, tags = [], location = '', metadata = {}, production_meta = {}, merge_file_status, merge_file_job = {} } = { ...batch }
        const { type, w, h, is_enable } = { ...metadata.frame }
        const { sewing_groups = [] } = production_meta
        const isCutOff = Array.isArray(tags) && tags.includes('cutoff')
        const isCutOffNoel = Array.isArray(tags) && tags.includes('cutoff_noel')
        const isCutOffNewYear = Array.isArray(tags) && tags.includes('cutoff_new_year')
        const isDlican = Array.isArray(tags) && tags.includes('Dlican')
        const isForceCmyk = Array.isArray(tags) && tags.includes('force_cmyk')
        const { isIccFlow, isReady } = Object.assign({}, data)
        const { processing_at, error_message } = Object.assign({}, merge_file_job)
        const isUnDisabledBtn = ["created", "done", "error"].includes(merge_file_status)

        const role = parseJwt(getLocalData('accessToken')).roles
        const isAdmin = role.some(item => ['Super Admin', 'fac_admin'].includes(item.name))

        const locationName = location ? LOCATION.find(i => i.value === location).label : ''

        const color = classNames({
            'pending progress-bar-animated progress-bar-striped': status === 'pending' || status === 'processing',
            'printing progress-bar-animated progress-bar-striped': status === 'printing',
            'printed': status === 'printed',
            'transferring progress-bar-animated progress-bar-striped': status === 'transferring',
            'transferred': status === 'transferred',
            'confirmed': status === 'confirmed',
            'wait-sew progress-bar-animated progress-bar-striped': status === 'wait_to_sew',
            'sewing': status === 'sewing',
            'completed': status === 'completed' || status === 'done',
        })

        const columns = [
            {
                title: 'Type',
                dataIndex: 'type',
                key: 'type',
            },
            {
                title: 'Size',
                dataIndex: 'size',
                key: 'size',
            },
            {
                title: 'Số lượng',
                dataIndex: 'quantity',
                key: 'quantity',
                align: 'center'
            },
        ]

        return (
            <div className="BatchInfo">
                {
                    !error ?
                        <div className='jumbotron p-3 mb-3'>
                            <div className={`${(isAdmin && isIccFlow === true) ? 'd-flex' : 'custom-grid'} align-items-center justify-content-between mb-3`}>
                                <div className="d-flex align-items-center">
                                    <h3 className="mb-0">Tên lô: <strong>{batch.name}</strong></h3>
                                    <div className="Status ml-2 d-flex align-items-center justify-content-between">
                                        <span className={`badge ${color || status} badge-pill`}>{status}</span>
                                        {isCutOff && <span className={`badge badge-pill ml-2`} style={{ background: "#FF6600", color: "white" }}>cutoff</span>}
                                        {isCutOffNoel && <span className={`badge badge-pill ml-2`} style={{ background: "#FF6600", color: "white" }}>cutoff_noel</span>}
                                        {isCutOffNewYear && <span className={`badge badge-pill ml-2`} style={{ background: "#FF6600", color: "white" }}>cutoff_new_year</span>}
                                        {isDlican && <span className={`badge badge-pill ml-2`} style={{ background: "#dc3644", color: "white" }}>Dlican</span>}
                                        {isForceCmyk && <span className={`badge badge-pill ml-2`} style={{ background: "#dc3644", color: "white" }}>force_cmyk</span>}
                                        <i className="fa fa-info-circle ml-2 cursor-pointer" style={{ fontSize: 20, marginRight: '60px' }} onClick={this.showModal} />
                                        {
                                            (isAdmin && _.get(batch, 'status') === "pending") &&
                                            <ChangeStatusTransferred batch={batch} refreshBatchInfo={refreshBatchInfo} />
                                        }

                                        {
                                            (isAdmin && _.get(batch, 'status') === "pending") &&
                                            <ChangeStatusSewing batch={batch} refreshBatchInfo={refreshBatchInfo} />
                                        }
                                    </div>
                                    <Modal title="Info item" visible={this.state.isModalOpen} onCancel={this.handleCancel} footer={null}>
                                        <Table
                                            dataSource={statistic_quantity}
                                            columns={columns}
                                            pagination={false}
                                            style={{ width: '100%', maxHeight: 500, overflowY: 'auto', overflowX: 'hidden' }}
                                        />
                                    </Modal>
                                </div>
                                <div>
                                    {/* {
                                        isAdmin &&
                                        <BatchMerge
                                            location="SW"
                                            loading={loading}
                                            id={batch._id}
                                            refreshBatchInfo={refreshBatchInfo}
                                            onActionSendMerge={onActionSendMerge}
                                            disabled={!isUnDisabledBtn}
                                            className="btn-crossed download-file"
                                            isReady={isReady}
                                            processingAt={processing_at}
                                            errorMessage={error_message}
                                            onHovering={this._handleHovering}
                                            hovering={hovering}
                                            mergeFileStatus={merge_file_status}
                                        />
                                    } */}
                                </div>
                                <div>
                                    {
                                        isAdmin && isIccFlow === true &&
                                        <Button
                                            type="primary"
                                            onClick={() => this._handleChangeModalForce(true)}
                                            disabled={tags.includes('force_rgb')}
                                            style={{
                                                backgroundColor: tags.includes('force_rgb') ? '#f5f5f5' : '#dc3644',
                                                borderColor: tags.includes('force_rgb') ? '#d9d9d9' : '#dc3644',
                                                color: tags.includes('force_rgb') ? '#00000040' : '#ffffff'
                                            }}
                                        >
                                            Force RGB
                                        </Button>
                                    }
                                </div>
                                <Modal
                                    title="Force RGB"
                                    visible={isOpenForce}
                                    onCancel={() => this._handleChangeModalForce(false)}
                                    cancelText="Đóng"
                                    footer={tags.includes('force_rgb') ? null : [
                                        <Button key="cancel" onClick={() => this._handleChangeModalForce(false)}>
                                            Hủy
                                        </Button>,
                                        <Button key="submit" type="primary" loading={loadingForce} disabled={loadingItems} onClick={this._handleForceToRGB}>
                                            Gen lại file in RGB
                                        </Button>,
                                    ]}
                                >
                                    {loadingItems ? (
                                        <div className="text-center py-4">
                                            <Spin />
                                        </div>
                                    ) : (
                                        <>
                                            <span style={{ fontSize: 16, fontWeight: 'bold' }}>Generate lại file in RGB cho {listItemNeedForce.length > 1 ? `${listItemNeedForce.length} items` : `${listItemNeedForce.length} item`}</span>
                                            <div className="list-item-force mt-2">
                                                {
                                                    listItemNeedForce.map(o => (
                                                        <div className="item-force" key={o}>{o}</div>
                                                    ))
                                                }
                                            </div>
                                            {retryFailed && !retrySuccess && (
                                                <div className="mt-3">
                                                    <div className="text-danger mb-2">
                                                        <i className="fa fa-exclamation-circle mr-2"></i>
                                                        Gen lại file in RGB thất bại. Vui lòng thử lại.
                                                    </div>
                                                    <Button
                                                        type="primary"
                                                        danger
                                                        onClick={this._handleManualRetry}
                                                        loading={loadingForce}
                                                    >
                                                        Thử lại
                                                    </Button>
                                                </div>
                                            )}
                                            {retrySuccess && (
                                                <div className="mt-3 text-success">
                                                    <i className="fa fa-check-circle mr-2"></i>
                                                    Gen lại file in RGB thành công
                                                </div>
                                            )}
                                        </>
                                    )}
                                </Modal>
                            </div>
                            <div><h6>Ngày tạo: <strong>{showDateTime(created_at)}</strong></h6></div>
                            {/*<div><h6>Người tạo: <strong>{batch.user_create}</strong></h6></div>*/}
                            <UserCreate
                                userCreate={batch.user_create}
                                batchId={batch._id}
                                status={status}
                                refreshBatchInfo={refreshBatchInfo}
                            />
                            {
                                (product_types.length === 1 && !!preference && !!preference.sku) && (
                                    <>
                                        <div><h6>Nguyên vật
                                            liệu: <strong>{joinMaterials(preference.sku.materials, preference.sku.sub_materials)}</strong>
                                            {!!type &&
                                                <>
                                                    <strong className='mx-1' style={{ fontSize: 20 }}>|</strong>
                                                    <Tooltip title={`${(!!w || w === 0) ? 'Width' : ''}${((!!w || w === 0) && (!!h || h === 0)) ? ' x ' : ''}${(!!h || h === 0) ? 'Height' : ''}`}>
                                                        <strong style={{ fontSize: 20, color: '#ff3b30' }}>
                                                            {`${(!!w || w === 0) ? w : ''}${((!!w || w === 0) && (!!h || h === 0)) ? ' x ' : ''}${(!!h || h === 0) ? h : ''}`}
                                                            {type === 'area' && ' (cm)'}
                                                        </strong>
                                                    </Tooltip>
                                                </>
                                            }
                                        </h6>
                                        </div>
                                        <div><h6>Mô
                                            tả: <strong className='text-break' style={{ whiteSpace: 'pre-line' }}>{!!preference.sku.description ? preference.sku.description.replace(/\\n/g, '\n') : ''}</strong>
                                        </h6>
                                        </div>
                                    </>
                                )
                            }
                            {/* <div><h6>Ghi chú: <small>{batch.note}</small></h6></div> */}
                            <BatchNote
                                note={batch.note}
                                batchId={batch._id}
                                refreshBatchInfo={refreshBatchInfo}
                            />
                            {
                                batch.hasOwnProperty('partner') &&
                                <BatchPartnerInfo
                                    partner={batch.partner}
                                    batchId={batch._id}
                                    status={status}
                                    refreshBatchInfo={refreshBatchInfo}
                                />
                            }

                            {
                                batch.hasOwnProperty('sewing_partner') &&
                                <SewingPartner
                                    partner={batch.sewing_partner}
                                    batchId={batch._id}
                                    receiveSewName={batch.receive_sew_name}
                                    receiveSewAt={batch.receive_sew_at}
                                    status={status}
                                    refreshBatchInfo={refreshBatchInfo}
                                    sewingGroups={sewing_groups}
                                    totalItems={total}
                                    reload={reload}
                                />
                            }

                            {
                                !!locationName &&
                                <div><h6>Địa điểm sản xuất: <strong>{locationName}</strong></h6></div>
                            }
                        </div>
                        : <div className='mb-3 text-danger'>{error}</div>
                }
            </div>
        )
    }
}

BatchInfo.propTypes = {
    batch: PropTypes.object.isRequired,
    error: PropTypes.string,
    refreshBatchInfo: PropTypes.func.isRequired

}

export default BatchInfo
